import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import React from 'react'

function NoResults(props: SvgIconProps) {
  return (
    <SvgIcon height="116" viewBox="0 0 150 116" width="150" {...props}>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="noResults-paint0_linear"
          x1="42.084"
          x2="5.26133"
          y1="-18.06"
          y2="83.072"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F4F6FD" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="noResults-paint1_linear"
          x1="29.2521"
          x2="78.1793"
          y1="21.1308"
          y2="105.523"
        >
          <stop stopColor="#EFF4FB" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="noResults-paint2_linear"
          x1="43.3774"
          x2="47.1218"
          y1="6.23384"
          y2="19.6213"
        >
          <stop stopColor="#EFF4FB" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="noResults-paint3_linear"
          x1="116.722"
          x2="122.87"
          y1="82.0049"
          y2="80.146"
        >
          <stop stopColor="#EFF4FC" />
          <stop offset="1" stopColor="#BBCBEA" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="noResults-paint4_linear"
          x1="112.894"
          x2="130.492"
          y1="91.0058"
          y2="109.209"
        >
          <stop stopColor="#EFF4FB" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="noResults-paint5_linear"
          x1="66.8805"
          x2="99.7555"
          y1="61.8128"
          y2="95.822"
        >
          <stop stopColor="#EFF4FB" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>
      </defs>
      <path
        clipRule="evenodd"
        d="M32.8299 0C15.6228 0.0342053 6.87271 15.8165 3.84783 22.2471C1.93807 26.3058 0.00808792 31.981 0 38.309V38.3891C0.0141539 48.6312 5.07517 60.5718 23.3943 70.1375C62.0606 83.5773 53.3064 105.184 84.8827 114.561C88.09 115.514 91.4261 115.998 94.7813 116H94.8905C116.988 115.966 138.487 95.6254 147.028 74.1024C153.349 58.1774 150.878 26.6381 126.886 14.851C113.243 8.14673 104.023 10.329 94.5346 12.5113C83.6199 15.021 72.3515 17.5317 53.5885 6.51074C45.6553 1.85295 38.8078 0.0127048 32.9401 0.000977295H32.8299V0Z"
        fill="url(#noResults-paint0_linear)"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M108.152 1.81335L108.172 93.1396L44.2358 93.1533V16.2597L59.1489 1.82313L108.152 1.81335Z"
        fill="url(#noResults-paint1_linear)"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M59.1458 1.82483L59.1488 16.2575L44.2185 16.2614L59.1458 1.82483Z"
        fill="url(#noResults-paint2_linear)"
        fillRule="evenodd"
      />
      <path
        d="M115.678 76.0879L122.001 82.1999"
        stroke="url(#noResults-paint3_linear)"
        strokeWidth="7"
      />
      <path
        clipRule="evenodd"
        d="M117.88 86.1859L131.973 99.8094C134.249 102.01 137.939 102.01 140.215 99.8094C142.491 97.6091 142.491 94.0418 140.215 91.8415L126.122 78.218L117.88 86.1859Z"
        fill="url(#noResults-paint4_linear)"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M83.8943 45.3652C74.4981 54.4492 74.4981 69.176 83.8943 78.26C93.2914 87.344 108.527 87.344 117.923 78.26C127.32 69.176 127.32 54.4492 117.923 45.3652C113.415 40.9964 107.292 38.5449 100.908 38.5535C94.5257 38.5454 88.4031 40.9965 83.8953 45.3643"
        fill="url(#noResults-paint5_linear)"
        fillRule="evenodd"
      />
    </SvgIcon>
  )
}

export default NoResults
